import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Sidebar from "./components/Sidebar";
import SignIn from "./components/SignIn";
import Home from "./components/Home";
import Deposit from "./components/Deposit";
import Withdraw from "./components/Withdraw";
import Analytics from "./components/Analytics";
import SignUp from "./components/SignUp";
import Confirmation from "./components/Confirmation";
import PhoneNumber from "./components/PhoneNumber";
import CreatePassword from "./components/CreatePassword";
import ProtectedRoute from "./components/ProtectedRoute";
import ContactUs from "./components/ContactUs";
import Premium from "./components/Premium";

import { AuthProvider } from "./context/AuthContext";
import ResetPassword from "./components/ResetPassword";

const AppContent = () => {
  const location = useLocation();

  // List of paths where the sidebar should be visible
  const sidebarPaths = [
    "/home",
    "/deposit",
    "/withdraw",
    "/analytics",
    "/premium",
    "/contactus",
  ];
  const showSidebar = sidebarPaths.includes(location.pathname);

  return (
    <div className="flex min-h-screen">
      {showSidebar && <Sidebar />}
      <div className={`flex-1 p-4 z-50 ${showSidebar ? "" : ""}`}>
        <Routes>
          <Route path="/" element={<Navigate to="/signin" />} />

          {/* Protected routes */}
          <Route path="/home" element={<ProtectedRoute element={<Home />} />} />
          <Route
            path="/deposit"
            element={<ProtectedRoute element={<Deposit />} />}
          />
          <Route
            path="/withdraw"
            element={<ProtectedRoute element={<Withdraw />} />}
          />
          <Route
            path="/analytics"
            element={<ProtectedRoute element={<Analytics />} />}
          />
          <Route
            path="/contactus"
            element={<ProtectedRoute element={<ContactUs />} />}
          />
          <Route
            path="/contactus"
            element={<ProtectedRoute element={<ContactUs />} />}
          />
          <Route
            path="/premium"
            element={<ProtectedRoute element={<Premium />} />}
          />

          {/* Public routes */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/confirmation" element={<Confirmation />} />
          <Route path="/phone_number" element={<PhoneNumber />} />
          <Route path="/create_password" element={<CreatePassword />} />
          <Route path="/resetpassword" element={<ResetPassword />} />
        </Routes>
      </div>
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
